import React, { useState } from 'react';
import { Link, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Email and password are required.');
      return;
    }
    setSubmitting(true);
    const res = await login(email.trim().toLowerCase(), password);
    setSubmitting(false);
    if (res.ok) {
      const dest = location.state?.from?.pathname || '/dashboard';
      navigate(dest, { replace: true });
    } else {
      setError(res.error || 'Login failed');
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card" data-testid="login-card">
        <div className="login-brand">
          <span className="brand-mark">NV</span>
          <div>
            <div style={{ fontWeight: 700, fontFamily: 'var(--font-heading)' }}>National Voter Guide</div>
            <div className="text-muted" style={{ fontSize: '0.85rem' }}>Admin console</div>
          </div>
        </div>

        <h2 style={{ fontSize: '1.4rem', marginBottom: 6 }}>Sign in</h2>
        <p className="text-muted" style={{ fontSize: '0.9rem', marginBottom: 22 }}>
          Use your administrator credentials to manage candidate profiles.
        </p>

        {error && (
          <Alert variant="danger" data-testid="login-error-alert">
            {error}
          </Alert>
        )}

        <Form onSubmit={handleSubmit} noValidate>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <Form.Label className="mb-0">Password</Form.Label>
              <Link
                to="/forgot-password"
                className="text-decoration-none"
                style={{ fontSize: '0.78rem' }}
                data-testid="login-forgot-password-link"
              >
                Forgot password?
              </Link>
            </div>
            <Form.Control
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
            />
          </Form.Group>
          <Button
            type="submit"
            variant="primary"
            className="w-100 mt-2"
            disabled={submitting}
            data-testid="login-submit-button"
          >
            {submitting ? <><Spinner size="sm" animation="border" /> Signing in…</> : 'Sign in'}
          </Button>
        </Form>
      </div>
    </div>
  );
}
